import React, {useEffect, useRef} from 'react';

import ClusterLevels from "../../../logic/ClusterLevels";
import ItemClusterSelectWidget from "./ItemClusterSelectWidget";
import SelectionHandler from "../../../logic/SelectonHandler";
import {getDispatch} from "../../../../Utility/ReduxHelper";
import groupItemsSlice from "../../../../ReduxStore/ProductGroupPage/groupItemsSlice";
import clsx from "clsx";

/**
 * ItemClusterLevel - one of the Select widgets within an
 * Item Cluster.
 *
 * props: ["name","cluster","clusterState"]
 */
export default function ItemClusterLevel({
  name, value = "", enabled, cluster, clusterState, position = 0,
  productAttributes, itemCache, ...props
}) {

  let {levelOptions, selections={}} = (clusterState || {});

  // get a ref to my top level element.
  const ref = useRef();

  // For all but the first one in each set, focus on it when it first appears,
  // because this probably means the user just selected the level above.
  useEffect(() => {
    const node = ref?.current;
    if (node && (position > 0)) {
      console.log(`REF CHANGED FOR ${name}`)
      focusOnMe(node);
    }
  }, [ref?.current]);

  const helper = new ClusterLevels({
    level: name, state: clusterState, cluster: cluster
  });

  // do not show application_id widget if there is just a single choice.
  let myOptions = levelOptions[name] || {};

  if (myOptions.hidden) {
    return null;
  }

  let choices = helper.getChoices();
  let upstream = helper.upstreamPath();

  const id = helper.getId();

  const handleSelect = (value) => {
    // let {target = {}} = (evt || {});
    // let value = target.value || "";

    //console.error(`CLUSTER LEVEL ${name} onSelect() - value ${value}`);
    const handler = new SelectionHandler({
      name, cluster, clusterState, itemCache, value
    });

    const newState = handler.getUpdatedState();

    const dispatch = getDispatch();

    dispatch(groupItemsSlice.actions.updateClusterState({
      clusterId: cluster.id,
      clusterState: newState
    }));
  }

  const className = clsx('relative grid gap-1 mb-2');
  const styles = {gridTemplateColumns: "40px 1fr"};

  let productAttribute = (productAttributes && productAttributes[name]) || {};

  // ID is like cluster-first_row_floor_liners-colour, the actual select widgets
  // append -select to this, which is used to locate the selector & give it focus
  return <div ref={ref} className={className} style={styles}>
    <div className="relative">
      <AttentionIcon value={value}/>
    </div>
    <div className="relative">
      <ItemClusterSelectWidget
        id={id + "-select"}
        name={name}
        value={value}
        choices={choices}
        onSelect={handleSelect}
        cluster={cluster}
        enabled={enabled}
        upstream={upstream}
        productAttribute={productAttribute}
      />
    </div>

  </div>
}

// Focus on the select element within our div.
function focusOnMe(topNode) {
  let selector = topNode?.querySelector('select');
  if (selector && selector.focus)
    selector.focus();
}

function AttentionIcon({value}) {
  // fa-wrapper is used for animation
  let wrapperClasses = [
    "fa-wrapper relative h-full w-full text-center  align-middle",
    "bg-gray-100 border-gray-500  rounded-sm border"
  ];
  let icon = value ? 'fa fa-check-circle text-brand-dark' : 'fa fa-arrow-right text-brand-bright ';

  let styles = {
    // animation: 'blink 0.75s',
    // animationIterationCount: 5
  }

  return <div className={clsx(wrapperClasses)} style={styles}>
    <span className={clsx('centered leading-none text-2xl text-shadow-2xs', icon)}/>
  </div>
}
